import { defineMessages } from 'react-intl';

export default defineMessages({
    pageTitle: {
        id: 'policy.view.policy-details.Policy Details',
        defaultMessage: 'Policy Details: {policyNumber}',
    },
    currentTab: {
        id: 'policy.view.policy-details.tab.Current',
        defaultMessage: 'Current',
    },
    changePolicy: {
        id: 'policy.view.policy-details.Change Policy',
        defaultMessage: 'Change Policy',
    },
    renewalTab: {
        id: 'policy.view.policy-details.tab.Renewing',
        defaultMessage: 'Renewal Offer',
    },
    DownloadIDCard: {
        id: 'policy.view.policy-details.Download ID Card',
        defaultMessage: 'Download ID Card',
    },
    editPaymentDetails: {
        id: 'policy.view.policy-details.Edit Payment Details',
        defaultMessage: 'Edit Payment Details',
    },
    documents: {
        id: 'policy.view.policy-details.Documents',
        defaultMessage: 'Documents',
    },
    paymentHistory: {
        id: 'policy.view.policy-details.Payment History',
        defaultMessage: 'Payment History',
    },
    editPaymentBanner:{
        id: "gateway.views.policy-details.You have Auto Pay turned on. Your payment will be drafted",
        defaultMessage: "You have Auto Pay turned on. Your payment will be drafted on {draftDate}."
    },
    errorPolicyHoldUW:{
        id: 'policy.view.policy-details.policy-moratorium.A policy moratorium is in effect for TWIA due to storm activity. No policies will be processed until after the moratorium is lifted.' ,
        defaultMessage: 'A policy moratorium is in effect for TWIA due to storm activity. No policies will be processed until after the moratorium is lifted.'
    },
    cantIssuePolicy: {
        id: 'policy.view.policy-details.policy-blocked.Your policy cannot be issued at this time. Please contact your agent for more information.',
        defaultMessage: 'Your policy cannot be issued at this time. Please contact your agent for more information.'
    },
    noTitle: {
        id: 'policy.view.policy-details.no-title',
        defaultMessage: ''
    }
});